import  {useContext} from 'react';
import { InputContext } from './InputContext';
import TextField from '@material-ui/core/TextField';
import './inputs.css';


const InputsPage = () => {
    const inputs = useContext(InputContext)


    return (
        <div className="inputsWrap">
            <TextField type="text"  variant="filled" placeholder="Give me a Negative Adjective" onChange={e => inputs.setNegAdj(e.target.value)} />
            <TextField type="text"  variant="filled" placeholder="Give me a Plural Noun" onChange={e => inputs.setPlNounOne(e.target.value)} />
            <TextField type="text"  variant="filled" placeholder="Give me another Plural Noun" onChange={e => inputs.setPlNounTwo(e.target.value)} />
            <TextField type="text"  variant="filled" placeholder="Can I have a Sea Creature" onChange={e => inputs.setSeaCre(e.target.value)} />
            <TextField type="text"  variant="filled" placeholder="How about an Insect" onChange={e => inputs.setInsect(e.target.value)} />
            <TextField type="text"  variant="filled" placeholder="Lastly, an Adjective" onChange={e => inputs.setAdj(e.target.value)} />
        </div>
    )
}

export default InputsPage
